module.exports = __webpack_public_path__ + "img/gem_pink_outline.ec84772b.png";